import { Centro } from './../centros/centro';
export class Unidade {
  id: number;
  descricao: string;
  centro_id:number;
  centro: Centro;

}



// WEBPACK FOOTER //
// ./src/app/unidades/unidade.ts